import React from "react";

export default function HeaderStats() {
  let url = window.location.href.split('admin/')[1];

  return (
    <>
    
      {
        url == 'dashboard' ?
          <div className="relative bg-dark-tertiary md:pt-32 pb-16 pt-12"></div>
          : <div className="relative bg-dark-tertiary md:pt-10 pb-16 pt-15">
           
          </div>
      }
      <div className="px-12 md:px-15 mx-auto w-full"></div>
    </>
  );
}
